import { MobileSheet } from "./mobile-sheet";
import { NavContent } from "./nav-content";

interface MobileNavPanelProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function MobileNavPanel({ open, onOpenChange }: MobileNavPanelProps) {
  return (
    <MobileSheet open={open} onClose={() => onOpenChange(false)}>
      <NavContent onNavigate={() => onOpenChange(false)} />
    </MobileSheet>
  );
}
